import { Loader2 } from "lucide-react";

export function FullScreenLoader({ label = "Checking your session" }) {
  return (
    <div data-testid="full-screen-loader" className="flex min-h-screen items-center justify-center bg-graphite-950">
      <div className="flex items-center gap-3 text-slate-400">
        <Loader2 className="h-4 w-4 animate-spin text-electric" strokeWidth={1.75} />
        <span className="bz-caption">{label}</span>
      </div>
    </div>
  );
}

export function Spinner({ className = "h-4 w-4" }) {
  return <Loader2 className={`${className} animate-spin`} strokeWidth={1.75} aria-hidden="true" />;
}
